import { Delete } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Box, Tooltip } from '@mui/material';
import BackendService from 'BackendService';
import React from 'react';
import Contact from '../../models/Contact';
import InvestmentEntityContact from '../../models/InvestmentEntityContact';
import {
  ContactAssociationStepBase,
  ContactAssociationStepProps,
} from '../InvestmentEntity/ContactAssociationStepBase';
import { StyledIconButton } from '../styles/StyledButtons';
import AdminModelCard from './AdminModelCard';

export class ContactAssociationStep extends ContactAssociationStepBase<ContactAssociationStepProps> {
  protected getBackendService(): BackendService {
    return new BackendService();
  }

  protected performSearch(query: string): void {
    if (query.trim().length < 2) {
      this.setState({
        searchResults: [],
        searchLoading: false,
      });
      return;
    }

    this.setState({ searchLoading: true });

    const backendService = this.getBackendService();
    backendService
      .searchContactsForEntity(query, this.props.entityId)
      .then((results) => {
        this.setState({
          searchResults: results,
          searchLoading: false,
        });
      })
      .catch((error) => {
        console.error('Error searching contacts:', error);
        this.setState({
          error: 'Failed to search contacts',
          searchLoading: false,
        });
      });
  }

  protected renderContactCard(contact: Contact, _isSearchResult: boolean): React.ReactNode {
    return (
      <Box key={contact.id} sx={{ position: 'relative' }}>
        <AdminModelCard
          entity={contact}
          hideViewButtons={true}
          actionButtons={
            <Tooltip title="Add Contact">
              <StyledIconButton
                onClick={() => this.handleAddContact(contact)}
                disabled={this.state.associating}
                sx={{
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                  color: 'rgba(0,0,0,0.8)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,1)',
                    color: 'rgba(0,0,0,1)',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '0.7rem',
                  },
                }}
              >
                <AddIcon />
              </StyledIconButton>
            </Tooltip>
          }
        />
      </Box>
    );
  }

  protected renderAssociatedContactCard(contact: InvestmentEntityContact): React.ReactNode {
    return (
      <Box key={contact.id} sx={{ position: 'relative', minWidth: '300px', flex: '0 0 auto' }}>
        <AdminModelCard
          entity={contact}
          name={contact.contact?.name || 'Unknown Contact'}
          email={contact.contact?.email || ''}
          tone="tone2"
          phone={contact.contact?.mobile || undefined}
          contactId={contact.contact?.id || contact.id}
          actionButtons={
            <Tooltip title="Remove Contact">
              <StyledIconButton
                onClick={() => this.handleDeleteContact(contact.contact?.id || contact.id)}
                disabled={this.state.associating}
                sx={{
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                  color: 'rgba(0,0,0,0.8)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,1)',
                    color: 'rgba(0,0,0,1)',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '0.7rem',
                  },
                }}
              >
                <Delete />
              </StyledIconButton>
            </Tooltip>
          }
        />
      </Box>
    );
  }
}
